import React, { useEffect, useState } from 'react'
import { Button, Chip, Column } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Page from '../../../internal/Page'
import SettingsPanel from '../../../internal/SettingsPanel'
import { getText } from '../../../internal/TextLabels'
import { useArrayState, useToggle } from '../../../util/utility-hooks'
import Select from '../../../midasComponents/components/Select'
import {
  CartItemMergeParamLabelTranslations,
  CartItemMergeParams,
} from '../../../models/constants'

const CartItemMergeSettings = ({ parameters, onSave }) => {
  const [
    cartItemMergeParams,
    setCartItemMergeParams,
    addCartItemMergeParam,
    removeCartItemMergeParam,
  ] = useArrayState([])
  const [availableParams, setAvailableParams] = useState([])
  const [selectedParam, setSelectedParam] = useState(null)
  const [edit, toggleEdit] = useToggle(false)

  useEffect(() => {
    setCartItemMergeParams(parameters)
  }, [parameters])

  useEffect(() => {
    setAvailableParams(
      Object.keys(CartItemMergeParams).filter(
        lhs => !cartItemMergeParams.find(rhs => lhs === rhs),
      ),
    )
  }, [cartItemMergeParams])

  useEffect(() => {
    if (availableParams && availableParams.length) {
      setSelectedParam(availableParams[0])
    } else {
      setSelectedParam(null)
    }
  }, [availableParams])

  const handleCancel = () => {
    setCartItemMergeParams(parameters)
    toggleEdit()
  }

  const handleSave = () => {
    onSave(cartItemMergeParams)
    toggleEdit()
  }

  return (
    <Page>
      <SettingsPanel
        header={getText('paymentSettings.cartParams.header')}
        buttons={
          edit
            ? [
                {
                  text: getText('default.cancel'),
                  action: handleCancel,
                },
                {
                  text: getText('default.save'),
                  type: 'primary',
                  action: handleSave,
                },
              ]
            : [
                {
                  text: getText('default.edit'),
                  action: toggleEdit,
                },
              ]
        }
      >
        <Column col4>
          <div style={{ marginTop: '1rem' }}>
            <label className={midas.formLabel}>
              {getText('paymentSettings.cartParams.addNewParam')}
            </label>
          </div>
        </Column>
        <Column col6>
          <Select
            id="availableCartItemMergeParams"
            value=""
            values={availableParams.map(param => ({
              key: param,
              value: param,
              valueLabel: getText(CartItemMergeParamLabelTranslations[param]),
            }))}
            disabled={!edit || !availableParams.length}
            onChange={value => setSelectedParam(value)}
          />
        </Column>
        <Column col2>
          <div style={{ marginTop: '1rem' }}>
            <Button
              id="addAvailableCartItemMergeParams"
              type="normal"
              text={getText('paymentSettings.cartParams.add')}
              disabled={!edit || !availableParams.length}
              onClick={() => addCartItemMergeParam(selectedParam)}
              fullWidth
            />
          </div>
        </Column>
        {!!cartItemMergeParams.length && (
          <>
            <Column col4 />
            <Column col8>
              {cartItemMergeParams.map((param, index) => (
                <Chip
                  key={param}
                  disabled={!edit}
                  close={edit}
                  onClose={() => removeCartItemMergeParam(index)}
                >
                  {getText(CartItemMergeParamLabelTranslations[param])}
                </Chip>
              ))}
            </Column>
          </>
        )}
      </SettingsPanel>
    </Page>
  )
}

CartItemMergeSettings.propTypes = {
  parameters: PropTypes.array,
  onSave: PropTypes.func.isRequired,
}

CartItemMergeSettings.defaultProps = {
  parameters: [],
}

export default connect()(CartItemMergeSettings)
